import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useMedia } from 'react-use';

const HomeSkeleton: FC = () => {
  const isMobile = useMedia('(max-width: 640px)');
  const isTablet = useMedia('(min-width: 641px) and (max-width: 1024px)');

  return (
    <div className="w-full">
      <div className="lg:flex">
        <div className="md:hidden w-full">
          <Skeleton count={1} height={200} />
        </div>
        <div className="hidden md:block w-full lg:w-full lg:pr-2">
          <Skeleton count={1} height={340} />
        </div>
      </div>
      <div className="mt-5 flex flex-wrap justify-between w-full">
        <div className={'flex gap-2'}>
          <Skeleton height={40} width={40} />
          <Skeleton height={40} width={isMobile ? 150 : 250} />
        </div>
        <Skeleton height={40} width={isMobile ? 100 : 140} />
      </div>
      <div className="mt-5 flex flex-wrap -mx-2">
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        {isMobile || isTablet ? (<div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>) : null}
      </div>
      <div className="mt-5 flex flex-wrap justify-between w-full">
        <div className={'flex gap-2'}>
          <Skeleton height={40} width={40} />
          <Skeleton height={40} width={isMobile ? 150 : 250} />
        </div>
        <Skeleton height={40} width={isMobile ? 100 : 140} />
      </div>
      <div className="mt-5 flex flex-wrap -mx-2">
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>
        {isMobile || isTablet ? (<div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>) : null}
      </div>
      <div className="mt-5 flex flex-wrap justify-between w-full">
        <div className={'flex gap-2'}>
          <Skeleton height={40} width={40} />
          <Skeleton height={40} width={isMobile ? 150 :250} />
        </div>
        <Skeleton height={40} width={isMobile ? 100 :140} />
      </div>
      <div className="mt-5 flex flex-wrap -mx-2">
        <div className="w-1/2 md:w-1/3 lg:w-1/4 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 300} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/4 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 300} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/4 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 300} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/4 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 300} />
        </div>
        <div className="w-1/2 md:w-1/3 lg:w-1/4 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 300} />
        </div>
        {isMobile || isTablet ? (<div className="w-1/2 md:w-1/3 lg:w-1/5 px-2 mt-2 lg:mt-0">
          <Skeleton height={isMobile || isTablet ? 300 : 400} />
        </div>) : null}
      </div>
    </div>
  );
};

export default HomeSkeleton;
